export const clientEndpoint = {
	// 全員可能
	login: "/login",
	loginVerify: "/login/verify",
	logout: "/logout",
	menu: "/menu",

	passwordResetMail: "/password-reset-mail",
	successPasswordResetMail: "/success-password-reset-mail",
	passwordReset: "/password-reset/:hash",
	successPasswordReset: "/success-password-reset",

	// 多要素認証
	mfaVerificationChallenge: "/mfa/verification-challenge",
	mfaSetup: "/mfa/setup",

	account: "/account",
	activity: "/activity",

	activityCreate: "/activity/:activityId",

	activityStatus: "/activity-status/:activityId",
	job: "/activity/:activityId/job",
	jobAll: "/job-all",
	jobSearch: "/job-search",
	jobDownload: "/job-download",
	jobCreate: "/activity/:activityId/job/:jobId",
	jobCreateRetest: "/activity/:activityId/retest/:retestJobId",

	question: "/question/:activityId/:jobId",

	jobStatus: "/job-status/:activityId/:jobId",
	jobDetail: "/job-detail/:activityId/:jobId",
	invoice: "/invoice/:activityId/:jobId",
	concept: "/concept/:activityId/:jobId",
	conceptPreview: "/concept_preview/:activityId/:jobId",
	quota: "/quota/:activityId/:jobId",
	application: "/application/:activityId/:jobId",
	approval: "/approval/:activityId/:jobId",
	preview: "/preview/:activityId/:jobId",

	// レポートページ
	outline: "/report/:activityId/:jobId/outline",
	exectiveReport: "/report/:activityId/:jobId/executive",
	evaluationReport: "/report/:activityId/:jobId/evaluation",
	simulationReport: "/report/:activityId/:jobId/simulation",
	conceptReport: "/report/:activityId/:jobId/concept",

	// version3のroute
	outlineLatest: "/report/latest/:activityId/:jobId/outline",
	exectiveReportLatest: "/report/latest/:activityId/:jobId/executive",
	simulationReportLatest: "/report/latest/:activityId/:jobId/simulation",
	resultByTargetReportLatest: "/report/latest/:activityId/:jobId/result-by-target",
	oaReportLatest: "/report/latest/:activityId/:jobId/oa",
	keyMeasurementsReportLatest: "/report/latest/:activityId/:jobId/key-mesurements",
	downloadReportLatest: "/report/latest/:activityId/:jobId/download",
	conceptReportLatest: "/report/latest/:activityId/:jobId/concept",

	// 以下ページは廃止
	conceptEvaluationReport: "/report/:activityId/:jobId/concept-evaluation",
	purchaseIntentProfileReport: "/report/:activityId/:jobId/purchase-intent-profile",
	downloadReport: "/report/:activityId/:jobId/download",
	skuReport: "/report/:activityId/:jobId/sku",

	// ここまで廃止。
	resultByTargetReport: "/report/:activityId/:jobId/result-by-target",
	oaReport: "/report/:activityId/:jobId/oa",
	keyMeasurementsReport: "/report/:activityId/:jobId/key-mesurements",

	// 固定ぱす
	permissionDenied: "/permission-denied",
	invalidUrl: "/invalid-url",

	aggregate: "/aggregate",
	aggtegateCreate: "/aggregate/:jobId/:aggregateId",
	aggtegateView: "/aggregate-view/:jobId/:aggregateId",

	// oshirase 設定画面
	infoEditPage: "/info/edit",

	// ノームフラグ管理ページ
	normFlags: "/norm-flags",

	// PDF
	guidelines: "/pdf/guidelines.pdf",
	adCopyGuidelines: "/pdf/ad-copy-guidelines.pdf",
	manual: "/pdf/manual.pdf",
	simulationManual: "/pdf/simulation-manual.pdf",
	simulationExplain: "https://shiseido.box.com/s/ab2hj94tpudkg77y6oxlkmozt41rllwu",
} as const;

export type ClientEndpoint = keyof typeof clientEndpoint;
export type ClientEndpointPath = (typeof clientEndpoint)[ClientEndpoint];
